import _objectSpread from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import jClassCard from 'src/components/modules/j-class-card.vue';
import debounce from 'quasar/src/utils/debounce.js';;
export default {
  name: 'pc-menu',
  components: {
    jClassCard: jClassCard
  },
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '菜单配置',
          icon: 'el-icon-chat-line-round',
          content: {
            list: [{
              label: '配置区域',
              link: {}
            }],
            logo: ''
          },
          config: [{
            label: '全局Logo',
            name: 'logo',
            type: 'image'
          }, {
            label: '菜单配置',
            name: 'list',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              link: {
                label: '链接',
                value: 'link'
              }
            }
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      show: false,
      isHome: true,
      keyword: '',
      tabs: '',
      searchList: [],
      searchVisible: false,
      initSearchParams: {
        goodsKeyWord: '',
        cateId: '',
        brandIdList: [],
        seriesIdList: [],
        attributeList: [],
        searchType: 1
      },
      searchPath: '/goods/search/all',
      searchConfig: {
        '/goods/search/all': '全部商品',
        '/goods/search/all?searchType=thzq': '特惠专区'
      },
      searchTypeVisible: false,
      hotSvg: require('@/assets/images/svg/hot_tag.svg'),
      recruitSvg: require('@/assets/images/svg/recruit_tag.svg')
    };
  },
  watch: {
    $route: {
      handler: function handler(val) {
        var _this = this;
        this.tabs = '';
        this.isHome = val.path == '/';
        this.keyword = this.$route.query.keyword || '';
        if (val.path !== '/goods/search/all' || val.query.searchType) {
          this.widgets.content.list.forEach(function (item, index) {
            if (item.link.path.includes(val.path)) {
              _this.tabs = index;
            }
          });
        }
        if (val.query.searchType === 'thzq') {
          this.searchPath = '/goods/search/all?searchType=thzq';
        } else {
          this.searchPath = '/goods/search/all';
        }
      },
      immediate: true
    }
  },
  created: function created() {},
  computed: {
    catNum: function catNum() {
      var _this$$store$state$ca;
      return (_this$$store$state$ca = this.$store.state.catCount) === null || _this$$store$state$ca === void 0 ? void 0 : _this$$store$state$ca.totalCount;
    },
    searchConfigArr: function searchConfigArr() {
      var _this2 = this;
      var resultArray = Object.keys(this.searchConfig).map(function (key) {
        return {
          key: key,
          value: _this2.searchConfig[key]
        };
      }).filter(function (m) {
        return m.key !== _this2.searchPath;
      });
      return resultArray;
    }
  },
  mounted: function mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    matchKeywordColor: function matchKeywordColor(item) {
      var regex = new RegExp(this.keyword, "gi");
      var highlightedText = item.replace(regex, function (match) {
        return "<span style=\"color: #000;\">".concat(match, "</span>");
      });
      return highlightedText;
    },
    jumpToUrl: function jumpToUrl(url) {
      this.$router.push(url);
    },
    handleClickOutside: function handleClickOutside(event) {
      if (this.searchVisible && this.$refs.searchRef && !this.$refs.searchRef.contains(event.target)) {
        this.searchVisible = false;
      }
      if (this.searchTypeVisible && this.$refs.searchRef && !this.$refs.searchRef.contains(event.target)) {
        this.searchTypeVisible = false;
      }
    },
    onFocusSearch: debounce(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this3 = this;
      var form, ret, isRefFocused, _ret;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!this.keyword) {
              _context.next = 9;
              break;
            }
            form = {
              goodsKeyWord: this.keyword,
              inactiveInventoryFlag: this.searchPath === '/goods/search/all' ? 10 : 20
            };
            _context.next = 4;
            return this.apiPost('/bbb/goodsInfo/suggestWithHitNum', form, false);
          case 4:
            ret = _context.sent;
            isRefFocused = function () {
              try {
                var refEl = _this3.$refs.searchInput;
                if (refEl && refEl.$el) refEl = refEl.$el;
                if (!refEl) return false;
                var inputEl = refEl.querySelector ? refEl.querySelector('input, textarea') || refEl : refEl;
                return inputEl === document.activeElement || inputEl.contains(document.activeElement);
              } catch (e) {
                return false;
              }
            }();
            if (isRefFocused) {
              this.searchList = ret.code == 200 ? ret.data || [] : [];
              this.searchVisible = ret.code == 200;
            }
            _context.next = 14;
            break;
          case 9:
            _context.next = 11;
            return this.apiPost('/bbb/goodsInfo/getTopSearchHistoryList', {}, false);
          case 11:
            _ret = _context.sent;
            this.searchList = _ret.code == 200 ? _ret.data || [] : [];
            this.searchVisible = _ret.code == 200;
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    })), 200),
    handleClickSearchItem: function handleClickSearchItem(item) {
      var _this4 = this;
      this.searchVisible = false;
      if (typeof item === 'string') {
        this.keyword = item;
      } else {
        this.keyword = item.keyword;
      }
      this.$nextTick(function () {
        _this4.search();
      });
    },
    search: function search(e) {
      this.searchVisible = false;
      this.searchTypeVisible = false;
      if (!this.keyword) return;
      this.addTrack('search_query', {
        userId: this.$store.state.userInfo.userId,
        keyWords: this.keyword
      });
      this.addTrack('search_active', {
        userId: this.$store.state.userInfo.userId,
        timeField: 'searchTime'
      });
      this.$router.push({
        path: this.searchPath,
        query: {
          keyword: this.keyword
        }
      });
      this.$store.commit('set_searchParams', _objectSpread(_objectSpread({}, this.initSearchParams), {}, {
        goodsKeyWord: this.keyword,
        correctionKeywordFlag: true
      }));
      if (e && e.target) {
        e.target.blur();
      }
    },
    handleLink: function handleLink(item) {
      this.addTrack('hotpoint_click', {
        userId: this.$store.state.userInfo.userId,
        hotpointWord: item.label,
        timeField: 'operateTime'
      });
      this.keyword = item.label;
    },
    handleTabsLink: function handleTabsLink(index, item) {
      var channelId = '';
      if (item.link.params.hasOwnProperty('id')) {
        channelId = item.link.params.id;
      }
      this.addTrack('channel_click', {
        channelId: channelId,
        channelLabel: item.label,
        userId: this.$store.state.userInfo.userId,
        timeField: 'operateTime'
      });
      this.tabs = index;
    },
    /**
     * 获取跳转方式
     */
    getTargetType: function getTargetType(item) {
      if (item.link.path === 'stockSupplier') {
        return '_blank';
      }
      return '';
    },
    /**
     * 获取是否开启提示
     */
    getIsHint: function getIsHint(item) {
      if (item.link.path === 'stockSupplier') {
        return false;
      }
      return true;
    }
  }
};